(() => {
  const pageWrapper = document.querySelector('.page-wrapper');
  if (!pageWrapper) return;

  let isScrollActive = false;
  let endTimer = 0;
  let timerFrame = 0;

  const clearScrollState = () => {
    if (timerFrame) window.cancelAnimationFrame(timerFrame);
    if (endTimer) window.clearTimeout(endTimer);
    timerFrame = 0;
    endTimer = 0;

    if (!isScrollActive) return;
    isScrollActive = false;
    pageWrapper.classList.remove('oz-scroll-active');
  };

  const scheduleScrollEnd = () => {
    if (timerFrame) return;

    timerFrame = window.requestAnimationFrame(() => {
      timerFrame = 0;
      if (endTimer) window.clearTimeout(endTimer);
      endTimer = window.setTimeout(clearScrollState, 120);
    });
  };

  const handleScroll = () => {
    if (!isScrollActive) {
      isScrollActive = true;
      pageWrapper.classList.add('oz-scroll-active');
    }

    scheduleScrollEnd();
  };

  const scrollTargets = [window, pageWrapper];
  for (const target of scrollTargets) {
    target.addEventListener('scroll', handleScroll, { passive: true });

    if ('onscrollend' in target) {
      target.addEventListener('scrollend', clearScrollState, { passive: true });
    }
  }

  window.addEventListener('pagehide', clearScrollState);
  window.addEventListener('pageshow', clearScrollState);
})();
